<template>
  <div class="nav">
    <img
      src="../assets/icons/ic_arrow_back_ios.png"
      alt=""
      v-if="$route.name != 'Home'"
      @click="$router.go(-1)"
    />

    <span class="title" :class="{ 'title-padding': $route.name == 'Home' }">{{
      $route.name
    }}</span>
    <div class="burger" @click="toggleMenu">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="menu" :class="{ 'hide-menu': !showMenu }" id="menu">
      <div class="card">
        <img
          src="../assets/icons/ic_close_orange.png"
          alt=""
          class="close"
          @click="toggleMenu"
        />
        <img src="../assets/avatar.svg" alt="" class="avatar" />
        <span class="info">{{ username }}</span>
        <button class="logout" @click="logout">Logout</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      showMenu: false,
      username: "",
    };
  },
  methods: {
    toggleMenu() {
      let menu = document.getElementById("menu");
      if (this.showMenu) {
        menu.style.backgroundColor = "transparent";
        setTimeout(() => {
          this.showMenu = false;
        }, 200);
      } else {
        this.showMenu = true;
        setTimeout(() => {
          menu.style.backgroundColor = "rgba(0, 0, 0, 0.185)";
        }, 200);
      }
    },
    logout() {
      localStorage.removeItem("rider_token");
      localStorage.removeItem("rider_phone");
      this.$router.push("/");
    },
  },
  created() {
    this.username = localStorage.getItem("rider_username");
  },
};
</script>

<style lang="scss" scoped>
.nav {
  width: 100%;
  height: var(--nav-height);
  border-bottom: 0.1rem solid orange;
  display: flex;
  align-items: center;
  padding: 0rem 1rem 0rem 0.2rem;
  background: var(--clr-ylw);
  box-shadow: var(--shadow);
  position: fixed;
  top: 0;
  left: 0;

  .burger {
    width: 4rem;
    height: 4rem;
    padding: 1.3rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: auto;
    div {
      width: 100%;
      height: 0.2rem;
      background: white;
      border-radius: 1rem;
    }
  }

  img {
    height: 4rem;
    padding: 1rem;
  }

  .title {
    font-size: 1.8rem;
    font-family: "P-800";
    color: white;
    margin-top: 0.2rem;
    text-transform: uppercase;
  }

  .title-padding {
    margin-left: 1.5rem !important;
  }

  .hide-menu {
    background: transparent !important;
    right: -100vw !important;
  }

  .menu {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 70;
    display: flex;
    transition: 0.25s all ease-in-out;

    .card {
      width: 70%;
      height: 100%;
      background: white;
      margin-left: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 70;

      .close {
        height: 6rem;
        margin-left: auto;
      }

      .avatar {
        width: 10rem;
        height: 10rem;
        margin: 2rem;
        box-shadow: var(--shadow);
        border-radius: 50%;
        border: 0.2rem dotted orange;
      }

      .info {
        font-size: 1.4rem;
        color: black;
        font-family: "P-300";
        padding: 0.2em 1rem;
      }

      .logout {
        width: calc(100% - 2rem);
        height: 5rem;
        color: #f44336 !important;
        border: 0.1rem solid #f44336 !important;
        border-radius: 0.4rem;
        background: transparent;
        border: none;
        outline: none;
        margin: 1rem;
        color: white;
        font-family: "P-600";
        text-transform: uppercase;
        margin-top: 3rem;
      }
    }
  }
}
</style>